<mat-icon>{{icon}}</mat-icon>



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/common/components/water.fall.container/card/action/card.action.component.html